interface MinimizeIconProps {
  fill?: string;
}
const MinimizeIcon = ({ fill }: MinimizeIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M13.5288 1.52876C13.7891 1.26841 14.2111 1.26841 14.4715 1.52876C14.7318 1.78911 14.7318 2.21112 14.4715 2.47147L10.9428 6.00011H13.3334C13.7016 6.00011 14.0001 6.29859 14.0001 6.66678C14.0001 7.03497 13.7016 7.33345 13.3334 7.33345H9.33345C8.96526 7.33345 8.66678 7.03497 8.66678 6.66678V2.66678C8.66678 2.29859 8.96526 2.00011 9.33345 2.00011C9.70164 2.00011 10.0001 2.29859 10.0001 2.66678V5.0574L13.5288 1.52876ZM7.33345 13.3334C7.33345 13.7016 7.03497 14.0001 6.66678 14.0001C6.29859 14.0001 6.00011 13.7016 6.00011 13.3334V10.9428L2.47147 14.4715C2.21112 14.7318 1.78911 14.7318 1.52876 14.4715C1.26841 14.2111 1.26841 13.7891 1.52876 13.5288L5.0574 10.0001H2.66678C2.29859 10.0001 2.00011 9.70164 2.00011 9.33345C2.00011 8.96526 2.29859 8.66678 2.66678 8.66678H6.66678C7.03497 8.66678 7.33345 8.96526 7.33345 9.33345V13.3334Z"
        fill={fill ?? "#313131"}
      />
    </svg>
  );
};

export default MinimizeIcon;
